import AuthChangeLicenceIdIconButton from '@/components/Auth/AuthChangeLicenceIdIconButton'
import AuthCurrentLicenceCard from '@/components/Auth/AuthCurrentLicenceCard'
import AuthProfileList from '@/components/Auth/Profiles/AuthProfileList'
import ChangeLicenceModal from '@/features/auth/components/ChangeLicenceModal'
import TitleWithHint from '@/features/auth/components/TitleWithHint'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { clearAuth } from '@/redux/reducers/auth'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import { Redirect } from 'expo-router'
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const AuthProfilesScreen: FC = () => {
    const licenceName = useAppSelector(authSelectors.licenceName)
    const licenceId = useAppSelector(authSelectors.licenceId)
    const profiles = useAppSelector(authSelectors.profiles)
    const [changeLicenceModalVisible, setChangeLicenceModalVisible] = useState(false)

    const dispatch = useAppDispatch()

    const { t } = useTranslation()

    if (!licenceName || !licenceId || !profiles) {
        return <Redirect href="/auth" />
    }

    return (
        <View style={styles.container}>
            <TitleWithHint
                title={t('profileScreensLogin')}
                hint={t('profileSelectionScreenSelectProfile')}
            />
            <AuthProfileList profiles={profiles} />
            <View style={styles.licenceSection}>
                <AuthCurrentLicenceCard
                    name={licenceName}
                    id={licenceId}
                    RightContent={
                        <AuthChangeLicenceIdIconButton
                            onPress={() => setChangeLicenceModalVisible(true)}
                            style={{ marginRight: 4 }}
                        />
                    }
                />
            </View>
            {changeLicenceModalVisible && (
                <ChangeLicenceModal
                    licenceName={licenceName}
                    onConfirm={() => {
                        setChangeLicenceModalVisible(false)
                        dispatch(clearAuth())
                    }}
                    onClose={() => setChangeLicenceModalVisible(false)}
                />
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: 'center',
        width: '100%',
    },
    licenceSection: {
        marginTop: 'auto',
        marginBottom: 64,
        alignItems: 'center',
    },
})

export default AuthProfilesScreen
